// removed by extract-text-webpack-plugin
module.exports = {"container":"i6O3m6z8WAEgY6wl9lm_f","message":"lXNVJlG0_FpRbR17N0HAq"};


//////////////////
// WEBPACK FOOTER
// ./src/client/Components/FullPageError/FullPageError.css
// module id = 991
// module chunks = 58